module.exports = __webpack_public_path__ + "media/assets/blue_trash-97325441e61a094558dcd86dda813b3fb8be7642d0de85bd123b439924c5f4c4.svg";